import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_UTILIZATION_FILTER_DATA_MODEL,
  REQUEST_UTILIZATION_USAGE_MODEL,
  REQUEST_UTILIZATION_TOTAL_SUMMARY_MODEL,
  REQUEST_UTILIZATION_TRANSITION_MODEL
} from '@/constants/savings-plans/utilizationConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/util/apiUtils';
import store from '@/store';

export function fetchFilterData(payload) {
  let fetchFilterDataPayload = {
    ...REQUEST_UTILIZATION_FILTER_DATA_MODEL
  };

  fetchFilterDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.SAVINGS_PLANS.UTILIZATION.FILTER_DATA, fetchFilterDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchUtilizationList(payload) {
  let fetchUsageListPayload = {
    ...REQUEST_UTILIZATION_USAGE_MODEL
  };

  fetchUsageListPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.SAVINGS_PLANS.UTILIZATION.USAGE_LIST, fetchUsageListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTotalSummary(payload) {
  let fetchTotalSummaryPayload = {
    ...REQUEST_UTILIZATION_TOTAL_SUMMARY_MODEL
  };

  fetchTotalSummaryPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.SAVINGS_PLANS.UTILIZATION.TOTAL_SUMMARY, fetchTotalSummaryPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTransition(payload) {
  let fetchTransitionPayload = {
    ...REQUEST_UTILIZATION_TRANSITION_MODEL
  };

  fetchTransitionPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.SAVINGS_PLANS.UTILIZATION.TRANSITION, fetchTransitionPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data.list') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}





// WEBPACK FOOTER //
// ./src/api/savings-plans/utilization/index.js